import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { NavLink } from 'react-router-dom'

import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import { theme } from '../../themes/theme'
import { BoldFormTitle } from '../styles/Text'
import { FlexRow } from '../styles/Containers'

const BreadcrumbContainer = styled(FlexRow)`
  align-items: center;

  .MuiSvgIcon-root {
    color: ${theme.colors.inputField.placeholder};
    height: 16px;
    transform: scale(1.9);
    transform-origin: center;
  }
`

const InactiveStep = styled(BoldFormTitle)`
  line-height: 22px;
  color: ${theme.colors.inputField.placeholder};
`

const ActiveStep = styled(BoldFormTitle)`
  line-height: 22px;
  color: ${theme.colors.text.heading};
`

const NavItem = styled(NavLink)`
  text-decoration: none;
`

function Breadcrumbs({ crumbs = [] }) {
  return (
    <BreadcrumbContainer>
      {crumbs.map((crumb, index) => {
        if (index === crumbs.length - 1)
          return (
            <BreadcrumbContainer key={index}>
              <ActiveStep>{crumb.label}</ActiveStep>
            </BreadcrumbContainer>
          )
        return (
          <BreadcrumbContainer key={index}>
            <NavItem to={crumb.path} aria-label={crumb.label}>
              <InactiveStep>{crumb.label}</InactiveStep>
            </NavItem>
            <NavigateNextIcon />
          </BreadcrumbContainer>
        )
      })}
    </BreadcrumbContainer>
  )
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array
}

export default Breadcrumbs
